<template>
  <b-sidebar id="add-new-user-sidebar" :visible="isAddNewUserSidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)">
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Create New Subject') }}
        </h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />

      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="handleSubmit(handleSurveyItem)" @reset.prevent="resetForm">
          <b-row>
            <b-col md="12">
              <label class="d-block mb-1 font-weight-semibold">{{ $t('Selection Mode') }}</label>
              <b-form-radio-group v-model="localOptions.rateSingleEmployee" name="some-radios" class="mb-2">
                <b-card 
                  class="radio-card mb-2 cursor-pointer" 
                  :class="{ 'radio-card-active': localOptions.rateSingleEmployee === true }"
                  @click="localOptions.rateSingleEmployee = true"
                  no-body
                >
                  <b-card-body class="p-2">
                    <div class="d-flex align-items-center">
                      <b-form-radio :value="true" class="mr-2" />
                      <div class="flex-grow-1">
                        <feather-icon icon="UserIcon" size="18" class="mr-1" />
                        <span class="font-weight-semibold">{{ $t('Rate Single Employee') }}</span>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
                
                <b-card 
                  class="radio-card cursor-pointer" 
                  :class="{ 'radio-card-active': localOptions.rateSingleEmployee === false }"
                  @click="localOptions.rateSingleEmployee = false"
                  no-body
                >
                  <b-card-body class="p-2">
                    <div class="d-flex align-items-center">
                      <b-form-radio :value="false" class="mr-2" />
                      <div class="flex-grow-1">
                        <feather-icon icon="UsersIcon" size="18" class="mr-1" />
                        <span class="font-weight-semibold">{{ $t('Rate Multiple Employees') }}</span>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-form-radio-group>
            </b-col>
          </b-row>

          <b-row v-if="!localOptions.rateSingleEmployee">
            <b-col md="12">
              <label class="d-block mb-1 font-weight-semibold">{{ $t('Filter By') }}</label>
              <b-form-radio-group v-model="searchType" name="multiple-employees" class="mb-2">
                <b-card 
                  class="radio-card mb-2 cursor-pointer" 
                  :class="{ 'radio-card-active': searchType === 'MODE_GROUP' }"
                  @click="searchType = 'MODE_GROUP'"
                  no-body
                >
                  <b-card-body class="p-2">
                    <div class="d-flex align-items-center">
                      <b-form-radio value="MODE_GROUP" class="mr-2" />
                      <div class="flex-grow-1">
                        <feather-icon icon="LayersIcon" size="18" class="mr-1" />
                        <span class="font-weight-semibold">{{ $t('Employee by Group') }}</span>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
                
                <b-card 
                  class="radio-card cursor-pointer" 
                  :class="{ 'radio-card-active': searchType === 'MODE_DEPARTMENT' }"
                  @click="searchType = 'MODE_DEPARTMENT'"
                  no-body
                >
                  <b-card-body class="p-2">
                    <div class="d-flex align-items-center">
                      <b-form-radio value="MODE_DEPARTMENT" class="mr-2" />
                      <div class="flex-grow-1">
                        <feather-icon icon="BriefcaseIcon" size="18" class="mr-1" />
                        <span class="font-weight-semibold">{{ $t('Employee by Department') }}</span>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-form-radio-group>
            </b-col>
          </b-row>

          <b-row v-if="!(localOptions.rateSingleEmployee) && searchType == 'MODE_GROUP'">
            <!--/ birth date -->
            <b-col md="12">
              <div class="demo-inline-spacing">
                <h5>{{ $t('Select Group') }}</h5>
                <group-picker class="col-12 " :initialCategories="groupSubject" @selectionChanged="valueChanged">
                </group-picker>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="!(localOptions.rateSingleEmployee) && searchType == 'MODE_DEPARTMENT'">
            <!--/ birth date -->
            <b-col md="12">
              <div class="demo-inline-spacing">
                <h5>{{ $t('Select Department') }}</h5>
                <department-picker class="col-12 " :initialCategories="departmentSubject"
                  @selectionChanged="valueChanged">
                </department-picker>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="!(localOptions.rateSingleEmployee) && searchType == 'MODE_POSITION'">
            <!--/ birth date -->
            <b-col md="12">
              <div class="demo-inline-spacing">
                <h5>{{ $t('Select Position') }}</h5>
                <position-picker class="col-12 " :multiple="Boolean(Boolean)" :initialCategories="positionSubject"
                  @selectionChanged="valueChanged">
                </position-picker>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="localOptions.rateSingleEmployee">
            <b-col class="mt-2" cols="12">
              <h5>{{ $t('Select Employees to Rate') }}</h5>
              <member-picker :searchOptions="searchOptions" @selectionChanged="selectionChanged">
              </member-picker>
            </b-col>
          </b-row>
          <b-row v-if="isMultiSelectEmployeeEnabled && searchType == 'MODE_DEPARTMENT'">
            <b-col class="mt-2" cols="12">
              <h5>{{ $t('Select Multiple Employees to Rate') }}</h5>
              
              <multi-member-by-department-picker :searchOptions="searchOptions" :searchType="searchType"
                :initialMembers="rateallSubjects" @selectionChanged="multipleEmplooyesChanged">

              </multi-member-by-department-picker>
            </b-col>
          </b-row>
          <b-row v-if="isMultiSelectEmployeeEnabled && searchType == 'MODE_GROUP'">
            <b-col class="mt-2" cols="12">
              <h5>{{ $t('Select Multiple Employees to Rate') }}</h5>
              
              <multi-member-by-group-picker :searchOptions="searchOptions" :searchType="searchType"
                :initialMembers="rateallSubjects" @selectionChanged="multipleEmplooyesChanged">

              </multi-member-by-group-picker>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <label class="d-block mb-1 font-weight-semibold">{{ $t('Rating Options') }}</label>
              
              <!-- Higher Positions Card -->
              <b-card 
                class="checkbox-card mb-2 cursor-pointer"
                :class="{ 'checkbox-card-active': rateHigherPositions }"
                @click="rateHigherPositions = !rateHigherPositions"
                no-body
              >
                <b-card-body class="p-2">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center flex-grow-1">
                      <div class="checkbox-icon-wrapper mr-2" :class="{ 'active': rateHigherPositions }">
                        <feather-icon icon="TrendingUpIcon" size="18" />
                      </div>
                      <span class="font-weight-semibold">{{ $t('Rate by Higher Positions') }}</span>
                    </div>
                    <b-form-checkbox 
                      v-model="rateHigherPositions" 
                      :value="true" 
                      class="custom-control-success mb-0"
                      @click.native.stop
                    />
                  </div>
                </b-card-body>
              </b-card>

              <!-- Lower Positions Card -->
              <b-card 
                class="checkbox-card mb-2 cursor-pointer"
                :class="{ 'checkbox-card-active': rateLowerPositions }"
                @click="rateLowerPositions = !rateLowerPositions"
                no-body
              >
                <b-card-body class="p-2">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center flex-grow-1">
                      <div class="checkbox-icon-wrapper mr-2" :class="{ 'active': rateLowerPositions }">
                        <feather-icon icon="TrendingDownIcon" size="18" />
                      </div>
                      <span class="font-weight-semibold">{{ $t('Rate by Lower Positions') }}</span>
                    </div>
                    <b-form-checkbox 
                      v-model="rateLowerPositions" 
                      :value="true" 
                      class="custom-control-success mb-0"
                      @click.native.stop
                    />
                  </div>
                </b-card-body>
              </b-card>

              <!-- Same Positions Card -->
              <b-card 
                class="checkbox-card mb-2 cursor-pointer"
                :class="{ 'checkbox-card-active': rateSamePositions }"
                @click="rateSamePositions = !rateSamePositions"
                no-body
              >
                <b-card-body class="p-2">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center flex-grow-1">
                      <div class="checkbox-icon-wrapper mr-2" :class="{ 'active': rateSamePositions }">
                        <feather-icon icon="MinusIcon" size="18" />
                      </div>
                      <span class="font-weight-semibold">{{ $t('Rate by Same Positions') }}</span>
                    </div>
                    <b-form-checkbox 
                      v-model="rateSamePositions" 
                      :value="true" 
                      class="custom-control-success mb-0"
                      @click.native.stop
                    />
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

          <!-- Form Actions -->
          <div class="d-flex mt-2 action-buttons">
            <b-button 
              v-ripple.400="'rgba(255, 255, 255, 0.15)'" 
              variant="primary" 
              type="submit" 
              class="mr-2 modern-button primary-button"
              v-if="!loading && rateallSubjects != null && rateallSubjects.length > 0"
            >
              <feather-icon icon="CheckIcon" size="16" class="mr-50" />
              {{ $t("Add") }}
            </b-button>
            
            <b-button 
              v-if="loading"
              variant="primary" 
              disabled
              class="mr-2 modern-button loading-button"
            >
              <b-spinner small class="mr-50" />
              {{ $t("Processing...") }}
            </b-button>

            <b-button 
              v-ripple.400="'rgba(186, 191, 199, 0.15)'" 
              type="button" 
              variant="outline-secondary"
              class="modern-button cancel-button"
              v-if="!loading" 
              @click="hide"
            >
              <feather-icon icon="XIcon" size="16" class="mr-50" />
              {{ $t("Cancel") }}
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BRow,
  BCol,
  BCard,
  BCardBody,
  BFormTextarea,
  BFormRadio,
  BFormRadioGroup,
  BCardText,
  BFormCheckbox, BListGroup, BListGroupItem, BSpinner
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'

import router from '@/router'
import SurveyTypePicker from '../components/SurveyTypePicker.vue'
import SurveyThemePicker from '../components/SurveyThemePicker.vue'
import MemberPicker from "@/views/members/component/MemberPicker.vue"
import DepartmentPicker from "@/views/department/components/DepartmentPicker.vue"
import BranchPicker from "@/views/branch/component/BranchPicker.vue"
import GroupPicker from "@/views/clientgroups/components/GroupSelector.vue"
import PositionPicker from "@/views/position/component/PositionPicker.vue"
import MultiMemberByDepartmentPicker from "@/views/members/component/MultiMemberByDepartmentPicker.vue"
import MultiMemberByGroupPicker from "@/views/members/component/MultiMemberByGroupPicker.vue"
import MemberMultiPicker from "@/views/members/component/MemberMultiPicker.vue"

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BFormTextarea,
    BFormRadio,
    BFormRadioGroup,
    BCardText,
    BFormCheckbox,
    vSelect,
    SurveyTypePicker,
    SurveyThemePicker,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    MemberPicker, DepartmentPicker,
    BranchPicker,
    GroupPicker,
    PositionPicker,
    MemberMultiPicker,
    MultiMemberByDepartmentPicker,
    MultiMemberByGroupPicker,
    BListGroup, BListGroupItem,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },
  },
  computed: {

    isMultiSelectEmployeeEnabled: function () {
      return this.searchType != null & this.searchOptions != null && !this.localOptions.rateSingleEmployee;
    },
    isSingleEmployee: function () {
      return this.localOptions.rateSingleEmployee
    },
    isSingleEmployeeCanAdd: function () {
      var t = this.localOptions.rateSingleEmployee && (this.rateallSubjects != null && this.rateallSubjects.length > 0)
      //console.log( this.rateallSubjects.length );
      //console.log(this.rateallSubjects);

      //console.log(t);
      return t;

    },
    isMultipleEmployee: function () {
      return !this.localOptions.rateSingleEmployee
    },
    showButtons: function () {
      return this.isSingleEmployeeCanAdd || this.isMultipleEmployee
    },
  },
  data() {
    return {
      required,
      alphaNum,
      loading: false,
      email,
      countries,
      rateHigherPositions: false,
      rateLowerPositions: true,
      rateSamePositions: true,
      searchOptions: null,
      searchType: null,
      groupSubject: null,
      branchSubject: null,
      departmentSubject: null,
      positionSubject: null,
      rateallSubjects: [],
      localOptions:
      {
        rateSingleEmployee: true,
        searchOptions: null,
        isMember: true,
        surveyitemtitle: null,
        surveyitemphoto: null,
        surveyitemmail: null,
        surveyitemmobile: null,
      }
    }
  },
  methods: {
    resetForm() {

    },
    handleSurveyItem() {
      {
        this.loading = true;
        this.localOptions.rateHigherPositions = this.rateHigherPositions;
        this.localOptions.rateLowerPositions = this.rateLowerPositions;
        this.localOptions.rateSamePositions = this.rateSamePositions;
        this.localOptions.rateallSubjects = this.rateallSubjects;
        this.localOptions.surveyid = router.currentRoute.query.s;
        store.dispatch('app-surveys/addSubject', this.localOptions)
          .then((response) => {
            var result = response.data.success;
            if (result != null && result != undefined && result == 200) {
              this.$emit('new-record-created')
              this.$emit('update:is-add-new-user-sidebar-active', false)
              this.$emit('refetch-data')
            } else {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Error`,
                  text: response.data.message,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
              this.loading = false;
            }
          }).catch((error) => {
            this.loading = false;
            this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Error`,
                  text: error.response?.data?.message || error.message,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
          })
      }
    },

    selectionChanged(payload) {
      if (payload == null) {
        this.rateallSubjects = [];

      } else {
        if (this.localOptions.rateSingleEmployee) {
          this.rateallSubjects = [];
        }
        this.rateallSubjects.push(payload);
      }

    },
    valueChanged(payload) {
      if (payload == null) {
        this.searchOptions = null;

      } else {
        this.searchOptions = payload;
      }

    },
    multipleEmplooyesChanged(payload) {
      this.rateallSubjects = payload;


    },  
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}

// Modern Kart Tabanlı Radio Butonlar
.radio-card {
  border: 2px solid #ebe9f1;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #7367f0;
    box-shadow: 0 4px 8px rgba(115, 103, 240, 0.15);
    transform: translateY(-2px);
  }
  
  &.radio-card-active {
    border-color: #7367f0;
    background-color: rgba(115, 103, 240, 0.08);
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.2);
  }
}

// Modern Kart Tabanlı Checkbox'lar
.checkbox-card {
  border: 2px solid #ebe9f1;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #28c76f;
    box-shadow: 0 4px 8px rgba(40, 199, 111, 0.15);
    transform: translateY(-2px);
  }
  
  &.checkbox-card-active {
    border-color: #28c76f;
    background-color: rgba(40, 199, 111, 0.08);
    box-shadow: 0 4px 12px rgba(40, 199, 111, 0.2);
  }
}

// İkon wrapper stili
.checkbox-icon-wrapper {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: #f8f8f8;
  transition: all 0.2s ease;
  
  &.active {
    background-color: #28c76f;
    color: white;
  }
}

.cursor-pointer {
  cursor: pointer;
}

// Modern Action Buttons
.action-buttons {
  gap: 8px;
  padding-top: 8px;
  
  .modern-button {
    font-weight: 600;
    padding: 10px 24px;
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: inline-flex;
    align-items: center;
    border-width: 2px;
    
    &.primary-button {
      background: linear-gradient(135deg, #7367f0 0%, #9055ff 100%);
      border-color: transparent;
      box-shadow: 0 4px 12px rgba(115, 103, 240, 0.3);
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(115, 103, 240, 0.4);
      }
      
      &:active {
        transform: translateY(0);
      }
    }
    
    &.loading-button {
      background: #7367f0;
      border-color: transparent;
      cursor: not-allowed;
      opacity: 0.8;
    }
    
    &.cancel-button {
      border-color: #d8d6de;
      color: #6e6b7b;
      background: white;
      
      &:hover {
        background: #f8f8f8;
        border-color: #7367f0;
        color: #7367f0;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(115, 103, 240, 0.15);
      }
      
      &:active {
        transform: translateY(0);
      }
    }
  }
}
</style>
